import { render, staticRenderFns } from "./SHomeHero.vue?vue&type=template&id=5ba5ceaa&scoped=true&"
import script from "./SHomeHero.vue?vue&type=script&lang=js&"
export * from "./SHomeHero.vue?vue&type=script&lang=js&"
import style0 from "./SHomeHero.vue?vue&type=style&index=0&id=5ba5ceaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba5ceaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VContainer,VIcon,VLayout})
